import { CSSProperties, forwardRef } from 'react';
import { SanitationLevel } from '@ardoq/html';
import { LargeImagePreviewModal } from './LargeImagePreviewModal';
import {
  useMarkdownImagePreview,
  ZoomableMarkdownViewer,
} from './useMarkdownImagePreview';

type MarkdownWithImagePreviewProps = {
  content: string;
  sanitationLevel: SanitationLevel;
  closeButtonText: string;
  zoomButtonLabel: string;
  className?: string;
  style?: CSSProperties;
};

/**
 * Renders markdown whose images open in a preview. Callers that place the
 * viewer inside a popover should use `useMarkdownImagePreview` directly and
 * mount `LargeImagePreviewModal` outside the popover instead.
 */
export const MarkdownWithImagePreview = forwardRef<
  HTMLDivElement,
  MarkdownWithImagePreviewProps
>(
  (
    {
      content,
      sanitationLevel,
      closeButtonText,
      zoomButtonLabel,
      className,
      style,
    },
    ref
  ) => {
    const { viewerProps, previewImageUrl, closePreview } =
      useMarkdownImagePreview(zoomButtonLabel);

    return (
      <>
        <ZoomableMarkdownViewer
          ref={ref}
          className={className}
          style={style}
          content={content}
          sanitationLevel={sanitationLevel}
          {...viewerProps}
        />
        <LargeImagePreviewModal
          imageUrl={previewImageUrl}
          onClose={closePreview}
          closeButtonText={closeButtonText}
        />
      </>
    );
  }
);

MarkdownWithImagePreview.displayName = 'MarkdownWithImagePreview';
